// oxlint-disable prefer-await-to-callbacks prefer-await-to-then require-hook
// Base styles load first, before any component that uses their variables

// oxlint-disable-next-line import/no-unassigned-import
import 'vuetify/styles';

// automatically imported by vite: variables.scss
import './styles/app_styles.scss';

// Overrides of Vuetify's base styles
import './styles/vuetify/vuetify-mods.scss';

// Base typography helpers through attributes and classes
import './styles/typography-helpers.scss';

import {createPinia} from 'pinia';
import {createPersistedState} from 'pinia-plugin-persistedstate';
import {createApp} from 'vue';

import {trpcClient} from '@shared_ui/trpc_client';
import {__APP_ENV__} from './app_env';
import {setupAppInstance, setupAppState} from './app_state';
import App from './App.vue';
import {createHttpInstance} from './http/http_instance';

import {vuetify} from './plugins/vuetify';
import {setupRoutes} from './router/route_setup';

import {installResize} from './directives/resize';
import {installVisible} from './directives/visible';
import {captureAnalyticsException, initAnalytics} from './plugins/analytics';
import {setupFontawesome} from './plugins/fontawesome_setup';

initAnalytics();

async function main(): Promise<void> {
   const app = createApp(App);

   app.config.errorHandler = (err) => {
      console.error('Unhandled application error', err);
      captureAnalyticsException(err);
   };

   const pinia = createPinia();
   pinia.use(
      createPersistedState({
         storage: globalThis.localStorage,
         key: (id) => `ab-store__${id}`,
      }),
   );
   app.use(pinia);

   const router = setupRoutes();
   app.use(router);

   app.use(vuetify);

   setupFontawesome(app);

   installResize(app);
   installVisible(app);

   // -- SETUP GLOBAL PROPERTIES -- //
   const http = createHttpInstance(router);
   app.config.globalProperties.$http = http;

   // Use a getter so $trpc always returns the current singleton,
   // even after resetTrpcClient() rebuilds it.
   Object.defineProperty(app.config.globalProperties, '$trpc', {
      get: () => trpcClient(),
      configurable: true,
   });

   setupAppState(app, http);

   console.log(`Loading app: ${__APP_ENV__.PACKAGE_VERSION}`);
   console.log(`  - Client Settings: `, {
      API_URL: __APP_ENV__.API_URL,
      environment: __APP_ENV__.PRODUCTION
         ? 'production'
         : __APP_ENV__.STAGING
           ? 'staging'
           : 'development',
   });

   const vm = app.mount('#app');
   setupAppInstance(app, vm);
}

main()
   .then(() => {
      console.log('Application startup completed.');
      return;
   })
   .catch((err) => {
      console.error('Failed to start application', err);
   });
